import UsersCell from './UserCell';

export default UsersCell;
